<template>
    <footer>
        <div class="flex flex-col md:flex-row p-28 justify-between h-full w-full space-x-6">
            <div >
                <h2 class="text-5xl text-white font-bold mb-20">Shortly</h2>
            </div>
            <div>
                <ul >
                    <li class="flex flex-col space-y-4">
                        <a href="#"><h2 class="text-white text-3xl font-bold">
                            Features
                        </h2></a>
                        <a href="#" class="text-gray-400  hover:text-blue-500">Link Shortening</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Branded Links</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Analytics</a>

                    </li>
                </ul>
            </div>
            <div>
                <ul>
                    <li class="flex flex-col space-y-4">
                        <a href="#"><h2 class="text-white text-3xl font-bold">
                            Resources
                        </h2></a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Blog</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Developers</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Support</a>

                    </li>
                </ul>
            </div>
            <div>
                <ul>
                    <li class="flex flex-col space-y-4">
                        <a href="#"><h2 class="text-white text-3xl font-bold">
                            Company
                        </h2></a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">About</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Our Team</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Careers</a>
                        <a href="#" class="text-gray-400 hover:text-blue-500">Contact</a>
                    </li>
                </ul>
            </div>
            <div>
                <li class="flex flex-row mx-auto justify-center align-center items-center">
                        <img src="../assets/images/icon-facebook.svg" class="object-scale-down h-20 w-20" alt="">
                        <img src="../assets/images/icon-twitter.svg" class="object-scale-down h-20 w-20" alt="">
                        <img src="../assets/images/icon-pinterest.svg" class="object-scale-down h-20 w-20" alt="">
                        <img src="../assets/images/icon-instagram.svg" class="object-scale-down h-20 w-20" alt="">
                    </li>
            </div>
        </div>
       <div class="text-white text-center">
    Challenge by <a href="https://www.frontendmentor.io" class="text-blue-500 underline" target="_blank">Frontend Mentor</a>. 
    Coded by <a href="https://www.linkedin.com/in/michael-olowe-7b600620a" target="_blank" class="text-blue-500 underline">Maiqel</a>.
    </div>
    </footer>
</template>

<script>
    export default{
        name: 'Footer'
    }
</script>

<style>
    footer{
        background-color: hsl(260, 8%, 14%);
        height: 100%;
        width: 100%;
    }
</style>